
import React from 'react';
import './policies.css';

function RefundReturnPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-container">

        <h1>Refund / Return Policy</h1>

        <p className="last-updated">
          Last Updated: January 2026
        </p>

        <div className="policy-welcome-box">
          <p>
            At <strong>Mr White</strong>, customer satisfaction is our top
            priority. This Refund / Return Policy outlines the conditions under
            which we accept returns and issue refunds.
          </p>
        </div>

        <div className="policy-section">
          <h2>1. General Policy</h2>

          <p>
            Due to the nature of laundry services, we typically do not accept
            returns of items once they have been processed. However, we are
            committed to addressing any concerns regarding the quality of our
            services.
          </p>
        </div>

        <div className="policy-section">
          <h2>2. Conditions for Refunds</h2>

          <p>
            Refunds may be issued under the following circumstances:
          </p>

          <ul className="policy-list">
            <li>
              <strong>Service Quality Issues:</strong> If you are unsatisfied
              with the quality of any laundry service due to stains that were
              not removed or damage to your items caused during cleaning,
              please notify us within 24 hours of receiving your laundry.
            </li>

            <li>
              <strong>Order Mistakes:</strong> If we have processed an order
              incorrectly (for example, incorrect items cleaned or wrong
              services provided), please contact us immediately.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Refund Process</h2>

          <p>
            To request a refund, please contact our customer service team at:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>

          <p>
            Please provide the following information:
          </p>

          <ul className="policy-list">
            <li>Your order number.</li>
            <li>A detailed description of the issue.</li>
            <li>Photographic evidence, if applicable.</li>
          </ul>

          <p>
            Our team will review your request and respond within
            <strong> 2 business days</strong>.
          </p>

          <p>
            If approved, the refund will be processed within
            <strong> 5–7 business days</strong> and credited back to the
            original payment method used for the transaction.
          </p>
        </div>

        <div className="policy-section">
          <h2>4. No Refunds for Certain Situations</h2>

          <p>
            Refunds will not be issued under the following circumstances:
          </p>

          <ul className="policy-list">
            <li>
              Customer items that have already been processed and delivered
              without any quality issues or service errors.
            </li>

            <li>
              Change of mind after an order has been placed.
            </li>

            <li>
              Damage caused by failure to follow care instructions provided
              with the clothing items.
            </li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Contact Us</h2>

          <p>
            For questions regarding this Refund / Return Policy or to initiate
            a refund request, please contact our customer service team:
          </p>

          <p>
            <strong>Email:</strong>{' '}
            <a href="mailto:customercare@mrwhiteuae.com">
              customercare@mrwhiteuae.com
            </a>
          </p>

          <p>
            <strong>Phone:</strong>{' '}
            <a href="tel:+971585779343">
              +971 58 577 9343
            </a>
          </p>
        </div>

      </div>
    </div>
  );
}

export default RefundReturnPolicy;

